let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("by3qk")).then(() => parcelRequire('k71l9'));